import { inject, observer } from "mobx-react";

import "./style.scss";

const Loader = inject("mainStore")(
    observer(({ mainStore }) => {
        const loader = mainStore.getMainStore("loader");

        return loader ? <div className={`loader ${loader ? "light-loader" : ""}`}></div> : null;
    }),
);

export default Loader;
